<template lang="html">
  <b-container class="page-search" :loading="is_loading" :std="filters.is_std">

    <div class="mb-4" v-if="$store.user">
      <h3>Vuoi segnalarci o vendere dei pallet in esubero? <a @click="$router.push('/user-area')" style="color:#81bb5d; cursor:pointer">Clicca qui</a></h3>
    </div>
    <!-- <div class="mb-4" v-else>
      <h3>Vuoi segnalarci o vendere dei pallet in esubero? <a @click="$store.show_login = true" style="color:#81bb5d; cursor:pointer">Login</a></h3>
    </div> -->
    <div class="mb-4" v-else>
      <h3>Vuoi diventare partner della rete? <a @click="registerUser()" style="color:#81bb5d; cursor:pointer">Registrati</a></h3>
    </div>

    <div class="mb-2">
      <h1>Che pallet stai cercando?</h1>
      <i>Compila il form qui sotto e avrai accesso alla lista di pallet che corrispondono alla tua richiesta</i>
    </div>
    <!-- <div class="mb-5" v-if="! $store.user">
      <button class="pulsante-registrati" type="button" @click="registerUser()">Registrati</button>
    </div> -->

    <div class="row reverse">
      <div class="col-md-12 pr-5">


        <b-form @submit.prevent="() => null" class="form-ricerca">
          <div>
            <b>Categoria di pallet:</b>
            <div class="mb-3 selezione-standard">
              <b-form-radio v-model="filters.category" :value="1">
                <span class="text-success">Standard</span>
              </b-form-radio>
              <b-form-radio v-model="filters.category" :value="2" selected="selected" style="padding-left:50px;">
                <span class="text-warning">Fuori Standard / Plastica</span>
              </b-form-radio>
              <b-form-radio v-model="filters.category" :value="3"  style="padding-left:50px;">
                <span class="text-info">Varie</span>
              </b-form-radio>
            </div>

            <div v-if="[1, 2].includes(filters.category)">
              <div v-if="filters.is_std" class="mb-4">
                <b>Seleziona categoria pallet</b>
                <b-select v-model="filters.product_type_id">
                  <option v-for="type in product_types" :key="type.id" :value="type.id">
                    {{ type.code }}
                  </option>
                </b-select>
              </div>


              <div class="row">
                <div class="col-md-6">
                  <h4 class="mb-3">Forma e dimensioni</h4>
                  <div class="row " style="padding-bottom:10px">
                    <div class="col-md-12">
                      Tipo di pallet:
                      <b-select v-model="filters.shape" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option>2 vie</option>
                        <option>4 vie</option>
                        <option>americano</option>
                      </b-select>
                    </div>
                  </div>
                  <div class="row " style="padding-bottom:10px;padding-top:10px; border-top:1px solid #ccc">
                    <div class="col-md-12">
                      Lato corto mm (A)
                      <b-input v-model="filters.side_a" :disabled="filters.is_std"/>
                    </div>
                    <div class="col-md-12" v-if="!filters.is_std">
                      Tolleranza
                      <b-select v-model="filters.side_a_tol" :disabled="filters.is_std">
                        <option :value="undefined">nessuna</option>
                        <option :value="30">+/- 30mm</option>
                        <option :value="50">+/- 50mm</option>
                      </b-select>
                    </div>
                  </div>
                  <div class="row " style="padding-top:10px;border-top:1px solid #ccc">
                    <div class="col-md-12">
                      Lato lungo mm (B)
                      <b-input v-model="filters.side_b" :disabled="filters.is_std"/>
                    </div>
                    <div class="col-md-12" v-if="!filters.is_std">
                      Tolleranza
                      <b-select v-model="filters.side_b_tol" :disabled="filters.is_std">
                        <option :value="undefined">nessuna</option>
                        <option :value="30">+/- 30mm</option>
                        <option :value="50">+/- 50mm</option>
                      </b-select>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" style="border-left: 1px solid #ccc;">
                  <h4 class=" mb-3">Altre specifiche</h4>
                  <div class="row">
                    <div class="col-md-12  col-sm-12 col-xs-12">
                      Portata
                      <b-select v-model="filters.weight_range" :disabled="filters.is_std">
                        <option v-if="filters.is_std">{{ filters.weight_range }}</option>
                        <option :value="undefined">Qualsiasi</option>
                        <option value="0-500">
                          LEGGERO - da 1 a 500 kg circa (spessore tav. fino a 15 mm. con TAPPO 6/8 cm)
                        </option>
                        <option value="501-1000">
                          FORTE - da 501 a 1000 Kg circa (spessore tav. da 16  a 20 mm. con TAPPO 9/10 cm.)
                        </option>
                        <option value="1001-99999">
                          ROBUSTO - da 1001 a 1500Kg circa (spessore tav. da 21 a 25 mm. con TAPPO 11/13 cm.)
                        </option>
                      </b-select>
                    </div>
                    <!-- <div class="col-md-6  col-sm-6 col-xs-6">
                      Tavole
                      <b-select v-model="filters.slab_count" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option>5</option>
                        <option>7</option>
                      </b-select>
                    </div> -->

                    <div class="col-md-12  col-sm-12 col-xs-12">
                      Perimetrato
                      <b-select v-model="filters.is_bounded" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option :value="true">Sì</option>
                        <option :value="false">No</option>
                      </b-select>
                    </div>
                    <div class="col-md-12  col-sm-12 col-xs-12">
                      Piano pieno
                      <b-select v-model="filters.is_filled" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option :value="true">Sì</option>
                        <option :value="false">No</option>
                      </b-select>
                    </div>

                    <div class="col-md-12  col-sm-12 col-xs-12">
                      Transpallet
                      <b-select v-model="filters.is_transpallet" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option :value="true">Sì</option>
                        <option :value="false">No</option>
                      </b-select>
                    </div>
                    <div class="col-md-12  col-sm-12 col-xs-12">
                      Reversibile
                      <b-select v-model="filters.reversable" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option :value="true">Sì</option>
                        <option :value="false">No</option>
                      </b-select>
                    </div>
                    <div class="col-md-12  col-sm-12 col-xs-12">
                      Contrario
                      <b-select v-model="filters.opposite" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option :value="true">Sì</option>
                        <option :value="false">No</option>
                      </b-select>
                    </div>
                    <div class="col-md-12  col-sm-12 col-xs-12">
                      Plastica
                      <b-select v-model="filters.is_plastic" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option :value="true">Sì</option>
                        <option :value="false">No</option>
                      </b-select>
                    </div>
                    <!-- <div class="col-md-6  col-sm-6 col-xs-6">
                      Trattato ht
                      <b-select v-model="filters.is_ht" :disabled="filters.is_std">
                        <option :value="undefined">Qualsiasi</option>
                        <option :value="true">Sì</option>
                        <option :value="false">No</option>
                      </b-select>
                    </div> -->
                  </div>
                </div>






              </div>
            </div>
            <div v-else class="small">
                <i>Seleziona la tipologia di pallet</i>
            </div>
          </div>
        </b-form>
      </div>

      <div class="col-md-12 mt-5">
        <div class="mb-4 text-center" v-if=" products &&  products.data.length != 0  ">
          <h4 class="mb-2">Pallet disponibili:</h4>
          <i v-if="!is_loading">Clicca sul pallet che vorresti richiedere</i>
          <i v-else>Caricamento...</i>
        </div>
        <div class="" v-if="isAdmin()">
          <div class="filtri-admin">
            <div class="filtro">
              <div class="intestazione">
                Filtra per regione
              </div>
              <div class="filtro-dati">
                <b-form-select v-model="filters.region" :options="region_options">
                </b-form-select>
              </div>
            </div>
            <div class="filtro">
              <div class="intestazione">
                Cerca un azienda e selezionala dal dropdown
              </div>
              <div class="filtro-dati">
                <div class="company-input">
                  <b-form-input v-model="search_value" placeholder="Filtra per azienda"></b-form-input>
                  <button class="btn btn-primary" @click="searchUsers"  >Cerca</button>
                </div>
                <b-select v-model="filters.user_id">
                  <option :value="null">Tutti</option>
                  <option v-for="u in users" :key="u.id" :value="u.id">{{ u.company }} ({{ u.name }} {{u.surname}} ){{u.type}}</option>
                </b-select>
              </div>
            </div>
          </div>
        </div>
        <div class="table table-responsive table-hover table-striped text-center nowrap">
          <!-- {{products.data}} -->
          <table class="w-100" v-if=" products &&  products.data.length != 0  ">
            <thead >
              <tr >
                <th></th>
                <th v-if="isAdmin()">Ragione Sociale<br>Partner</th>
                <th class="text-left w-50">Codice prodotto</th>
                <th v-if="!filters.is_varie">Lato corto</th>
                <th v-if="!filters.is_varie">Lato lungo</th>
                <th v-if="!filters.is_varie">Tipo</th>
                <th v-if="!filters.is_varie">Portata</th>
                <th v-if="!filters.is_varie">Specifiche</th>
                <th v-if="filters.is_varie">Descrizione</th>
                <th>Quantità</th>
                <!-- <th>Data di inserimento</th> -->
                <th v-if="isAdmin()">Regione</th>
                <th v-if="isAdmin()">Azienda</th>
                <th v-if="isAdmin()">Riferimento<br>Offerente</th>
                <th v-if="isAdmin()">Modifica</th>
              </tr>

            </thead>



            <tbody  v-if="products">

              <tr class="pointer" v-for="product in products.data" :key="product.id" @click="selection = product" v-b-tooltip.hover.topleft title="Clicca per inviare una richiesta">
                <td>
                  <img v-if="product.images.length" :src="$url(product.images[0].thumb.sm)" style="width:3rem"/>
                </td>

                <td v-if="isAdmin()">
                  <!-- {{product.user.user_code}} -->
                  {{product.user.company}}
                </td>

                <td class="text-left" v-if="product.is_varie">
                  <span class="text-info">
                    Varie
                    <!-- {{ product.name }} -->
                  </span>
                </td>
                <td class="text-left" v-else-if="product.product_type.is_std">
                  <span :class="product.product_type.is_std ? 'text-success' : 'text-warning'">
                    {{ product.product_type.code }}
                    <!-- {{ product.name }} -->
                  </span>
                </td>
                <td class="text-left" v-else>
                  <span :class="product.product_type.is_std ? 'text-success' : 'text-warning'">
                    Fuori Standard
                    <!-- {{ product.name }} -->

                  </span>
                </td>






                <td v-if="product.product_type">
                  {{ product.product_type.side_a }}
                </td>
                <td v-if="product.product_type">
                  {{ product.product_type.side_b }}
                </td>

                <td v-if="product.product_type">
                  {{ product.product_type.shape }}
                </td>
                <td v-if="product.product_type">
                  <span v-if="product.product_type.weight_range <= 500 ">Leggero</span>
                  <span v-else-if="product.product_type.weight_range >= 1001 ">Robusto</span>
                  <span v-else>Forte</span>
                  <!-- {{ product.product_type.weight_range }}kg -->
                </td>
                <td class="features" v-if="product.product_type">
                  <div class="feature" v-if="product.product_type.is_transpallet">
                    SI Transpallet
                  </div>
                  <div class="feature" v-else>
                    NO Transpallet
                  </div>
                  <div class="feature" v-if="product.product_type.reversable">
                    Reversibile
                  </div>
                  <div class="feature" v-if="product.product_type.is_bounded">
                    Perimetrato
                  </div>
                  <div class="feature" v-if="product.product_type.is_filled">
                    Piano pieno
                  </div>
                  <div class="feature" v-if="product.product_type.opposite">
                    Contrario
                  </div>
                  <!-- <div class="feature" v-if="product.product_type.is_ht">
                    Trattato ht
                  </div> -->
                </td>
                <td  v-if="filters.is_varie">
                  {{ product.description }}
                </td>
                <td>{{ product.quantity }}</td>


                <!-- <td>{{ product.created_at.split(' ')[0] }}</td> -->

                <td v-if="isAdmin()">
                  {{product.user.region}}
                </td>
                <td v-if="isAdmin()">
                  {{product.user.company}}
                </td>
                <td v-if="isAdmin()">
                  {{product.user.name}}<br>{{product.user.surname}}
                </td>
                <td v-if="isAdmin()">
                  <div class="edit-button">
                    <button type="button" v-on:click.stop="openEditForm(product)">
                      Modifica
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>






          </table>
          <div v-else class="blocco-richiesta">
            Nessun risultato tovato<br>
            Lasciaci i dati del pallet che stai cercando, ti ricontatteremo.<br>
            <!-- <product-request v-if="form" :form="form" @close="form=null"/> -->
            <ProductRequest class="form-richiesta"></ProductRequest>


          </div>
        </div>

        <b-pagination v-if="products && products.last_page > 1"
        :total-rows="products.total"
        :per-page="products.per_page"
        first-text="<<"
        prev-text="<"
        next-text=">"
        last-text=">>"
        v-model="page"
        />
        <!-- <pre>{{ filters }}</pre> -->
      </div>
    </div>
    <b-modal :visible="!!form" @hidden="form = null" hide-footer hide-header size="lg">
      <product-form v-if="form" :form="form" @saved="refreshProducts()" @close="form=null"/>
    </b-modal>


    <b-modal :visible="!!selection" @hidden="selection = null" hide-footer hide-header>
      <order-request v-if="selection" :product="selection" @close="selection = null"/>
    </b-modal>

  </b-container>
</template>

<script>
import OrderRequest from '@/components/order-request'
import ProductForm from '@/components/product-form'
import ProductRequest from '@/components/product-request'

export default {
  components: {
    OrderRequest,
    ProductForm,
    ProductRequest
  },
  data() {
    return {
      products: null,
      users: null,
      page: 1,
      filters: {
        is_std: false,
        category: 2,
      },
      is_loading: false,
      selection: null,
      form: null,
      search_value: null,
      region_options: [
        { value: null, text: 'Tutte'},
        { value: 'Abruzzo', text: 'Abruzzo'},
        { value: 'Basilicata', text: 'Basilicata'},
        { value: 'Calabria', text: 'Calabria'},
        { value: 'Campania', text: 'Campania'},
        { value: 'Emilia-Romagna', text: 'Emilia-Romagna'},
        { value: 'Friuli-Venezia Giulia', text: 'Friuli-Venezia Giulia'},
        { value: 'Lazio', text: 'Lazio'},
        { value: 'Liguria', text: 'Liguria'},
        { value: 'Lombardia', text: 'Lombardia'},
        { value: 'Marche', text: 'Marche'},
        { value: 'Molise', text: 'Molise'},
        { value: 'Piemonte', text: 'Piemonte'},
        { value: 'Puglia', text: 'Puglia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Sicilia', text: 'Sicilia'},
        { value: 'Sardegna', text: 'Sardegna'},
        { value: 'Toscana', text: 'Toscana'},
        { value: 'Trentino-Alto Adige', text: 'Trentino-Alto Adige'},
        { value: 'Umbria', text: 'Umbria'},
        { value: "Val d'aosta", text: "Val d'aosta"},
        { value: 'Veneto', text: 'Veneto'}
      ],
    }
  },

  computed: {
    is_ready() {
      return this.products && this.product_types
    },
  },

  created() {
    // this.refreshUsers()
    if (this.isAdmin()) {
      // this.refreshUsers()
      this.refreshPartners()
    }
    this.refreshProducts()
    this.refreshProductTypes()
  },
  methods: {
    triggerRefresh: window._.debounce(function() {
      this.refreshProducts()
    }, 300),
    refreshProducts() {
      this.is_loading = true
      let params = Object.assign({
        user_id: this.filters.user_id,
        page: this.page,
        is_varie : typeof this.filters.is_std != "boolean"
      }, this.filters)

      this.$http.get('products', {
        params
      }).then(res => {
        this.products = res.data
        console.log(this.products)
      }).finally(() => {
        this.is_loading = false
      })
    },

    refreshProductTypes() {
      this.$http.get('product-types', {
        params: {
          only_std: true
        }
      }).then(res => {
        this.product_types = res.data
      })
    },
    searchUsers(){

      let params= {
        searched_value: this.search_value,
        userType: "partner",
      }
      this.$http.get('users', {
        params
      }).then(res => {
        this.users = res.data
      })
    },
    refreshPartners(){
      console.log("aggiornamento partners")
      let params = {
        userType: "partner",
      }
      this.$http.get('users' , {
        params
      }).then(res => {
        this.users = res.data
      })
    },
    refreshUsers() {
      this.$http.get('users').then(res => {
        this.users = res.data
      })
    },
    isAdmin(){
      if(this.$store.user && this.$store.user.type == 'admin'){
        return true
      } else{
        return false
      }
    },
    openEditForm(product){
      this.form = this._.cloneDeep(product)
    },
    registerUser(){
      if(!this.$store.user){
        this.$store.show_signup = true
      }
    }
  },
  watch: {
    page() {
      this.refreshProducts()
    },
    filters: {
      deep: true,
      handler() {
        this.page = 1
        this.triggerRefresh()
      },
    },

    'filters.product_type_id'(id) {
      let pt = this.product_types.find(x => x.id == id)
      if (!pt) return null
      for (var prop in pt) {
        if (['id'].includes(prop)) continue
        this.$set(this.filters, prop, pt[prop])
      }
    },
    'filters.category'(v) {
      this.products = null


      if (v == 1) {
        this.filters = {
          is_std: true,
          category: v,
        }
      } else if (v == 2){
        this.filters = {
          is_std: false,
          category: v,
        }
      } else if(v == 3){
        this.filters = {
          is_varie: true,
          category: v,
        }
      }
    },
  }


}
</script>

<style lang="scss">
.page-search {
  padding-bottom:100px;
    .table {
        transition: 0.2s;

        .features {
            text-align: left;
            .feature {
                color: #000;
            }
        }
    }
    &[loading] {
        .table {
            opacity: 0.3;
        }
    }
    &[std] {
        input, select {
          &[disabled] {
            background: transparent;
            border: none;
            color: var(--primary);
          }
        }
    }
}

</style>
<style media="screen">
.form-ricerca .custom-select{
  padding-top: 2px;
  padding-bottom:2px;
}
.filtri-admin{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.filtro{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  width: 100%;
  padding-bottom:20px;
}
.filtro div{
  width: 100%;
}
.company-input{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width:100%;
}
.selezione-standard{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  padding-top:10px;
}


@media only screen and (max-width: 1090px){
  .logout-button{
    display: none;
  }
}
/* @media only screen and (max-width: 460px){
  .main-menu .nav-link{
    font-size: 1.0rem;
  }
} */
@media only screen and (max-width: 767px){
  .reverse{
    flex-direction: column-reverse;
  }
}
.edit-button button{
    color: white;
    background-color: #81bb5d;
    border:1px solid #81bb5d;
    border-radius:20px;
    padding: 10px 20px;
  }
  .form-richiesta{
    padding-top:30px;
  }
  .blocco-richiesta{
    border-top:3px solid #81bb5d;
    padding-top:20px;
  }
  .pulsante-registrati{
    margin-top:20px;
    padding:10px 20px;
    border: 1px solid #81bb5d;
    border-radius:20px;
    font-size:20px;
    color:white;
    background-color:#81bb5d;
  }
</style>
